import { createContext, useState } from 'react';
import api from 'services/api';

export const CrmContext = createContext();

export const CrmProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getFunil = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Comercial/Crm/Funil', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getLeads = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Comercial/Crm/Leads', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postLead = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Crm/Lead', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumento = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Crm/Documento', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getHistorico = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Comercial/Crm/Historico', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postHistorico = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Crm/Historico', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteHistorico = async ({ id, cb }) => {
    try {
      setPostLoading(true);
      await api.delete(`/Comercial/Crm/Historico/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <CrmContext.Provider
      value={{
        getLoading,
        getFunil,
        getLeads,
        postLead,
        postLoading,
        postDocumento,
        getHistorico,
        postHistorico,
        deleteLoading,
        deleteHistorico,
      }}
    >
      {children}
    </CrmContext.Provider>
  );
};
